// extracted by mini-css-extract-plugin
export default {"uploadButton":"EditableCell_uploadButton__6u0xh"};